<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>CODE DE VALIDATION</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>CODE DE VALIDATION</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="login-area pt-100 pb-170">
    <div class="container">
        <div class="row align-items-center bg-white shadow rounded-4 overflow-hidden">
            <!-- Colonne de gauche avec image et texte explicatif -->
            <div class="col-lg-6 p-0 d-none d-lg-block">
                <div class="login-image-container position-relative">
                    <img src="./assets/img/upload/home/section-1.png" alt="Validation QUALIFPME" class="img-fluid w-100" style="height: 100%; object-fit: cover;">
                    <div class="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center p-5" style="background: linear-gradient(to right, rgba(0, 83, 62, 0.9), rgba(0, 83, 62, 0.7), rgba(0, 83, 62, 0.4))">
                        <h2 class="text-white mb-4 fw-bold">Vérification en deux étapes</h2>
                        <div class="mb-4">
                            <p class="text-white mb-3">Pour sécuriser votre compte, nous avons envoyé un code de validation à votre adresse email.</p>
                            <ul class="text-white ps-3">
                                <li class="mb-2">Vérifiez votre boîte de réception</li>
                                <li class="mb-2">Consultez également vos spams si nécessaire</li>
                                <li class="mb-2">Le code est valide pendant 10 minutes</li>
                                <li class="mb-2">Ne partagez jamais ce code avec d'autres personnes</li>
                            </ul>
                        </div>
                        <div class="bg-white p-3 rounded-3 mb-3 shadow-sm">
                            <p class="text-dark mb-0 fst-italic"><i class="icofont-info-circle text-primary me-2"></i>Cette étape de vérification protège votre compte contre les accès non autorisés.</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Colonne de droite avec le formulaire -->
            <div class="col-lg-6 p-5">
                <div class="login-form-container">
                    <div class="text-center mb-4">
                        <img src="./assets/img/LOGO_BSTP.png" alt="Logo QUALIFPME" height="60" class="mb-3">
                        <h2 class="mb-2">Validation de votre compte</h2>
                        <p class="text-muted">Veuillez saisir le code à 6 chiffres reçu par email</p>
                    </div>
                    
                    <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
                        <div class="form-group mb-4">
                            <label for="code" class="form-label">Code de validation</label>
                            <div class="input-group">
                                <span class="input-group-text"><i class="icofont-key"></i></span>
                                <input
                                    class="form-control"
                                    type="text"
                                    formControlName="code"
                                    placeholder="Saisissez le code à 6 chiffres"
                                    aria-label="Code de validation"
                                    maxlength="8"
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                    mask="00 00 00"
                                />
                            </div>
                            <small class="form-text text-muted">Saisissez le code à 6 chiffres que nous avons envoyé à votre adresse email.</small>
                        </div>

                        <div class="form-group mb-4">
                            <label class="form-label">Vérification de sécurité</label>
                            <re-captcha
                                class="w-100"
                                id="recaptcha"
                                formControlName="recaptcha"
                            ></re-captcha>
                        </div>

                        <div class="d-grid gap-2">
                            <button type="submit" class="btn btn-green btn-lg" [disabled]="form.invalid || loading">
                                <i class="icofont-verification-check me-2"></i> VALIDER LE CODE
                                <i *ngIf="loading" class="icofont-spinner-alt-1 icofont-spin ms-2"></i>
                            </button>
                        </div>
                        
                        <div class="text-center mt-4">
                            <p class="message">
                                Vous n'avez pas reçu de code?
                                <a class="text-default fw-bold" routerLink="/login-as-company">Réessayer</a>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <app-loading [loading]="loading" /> -->
